import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import { PlanTradUnsignedGuard } from '@app/plan-blocked.guard';
import { RenegotiationModule } from '@app/renegotiation/renegotiation.module';
import { UnsignedContractGuard } from '@app/unsigned-contract.guard';

import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { AuthenticationModule } from './authentication/authentication.module';
import { BpApiModule } from './bpApi/bpApi.module';
import { CheckupBffModule } from './checkup-bff/checkup-bff.module';
import { ContributionManagerBffModule } from './contribution-manager-bff/new-contribution-bff.module';
import { DecumulationApiModule } from './decumulation-api/decumulation-api.module';
import { DecumulationBffModule } from './decumulation-bff/decumulation-bff.module';
import { DepartureDateBffModule } from './departure-date-bff/departure-bff.module';
import { DigitalSiteBffModule } from './digital-site-bff/digital-site-bff.module';
import { ErrorsModule } from './errors';
import { ExtraContributionBffModule } from './extra-contribution-bff/extra-contribution-bff.module';
import { FeatureFlagGuard } from './feature-flag/feature-flag.guard';
import { FeatureFlagService } from './feature-flag/feature-flag.service';
import { JaiminhoApiModule } from './jaiminho-api/jaiminho-api.module';
import { LGPDBffModule } from './lgpd-api/lgpdBff.module';
import { LoginModule } from './login/login.module';
import { NewContributionBffModule } from './new-contribution-bff/new-contribution-bff.module';
import { NewDiversificationModule } from './new-diversification/new-diversification.module';
import { PortalModule } from './portal-bff/portal.module';
import { RatingApiModule } from './rating-api/rating-api.module';
import { ValidationBffModule } from './validation-bff/validation-bff.module';

@NgModule({
  exports: [],
  declarations: [],
  imports: [
    CommonModule,
    ErrorsModule,
    BpApiModule,
    AuthenticationModule,
    LoginModule,
    CheckupBffModule,
    DecumulationApiModule,
    DecumulationBffModule,
    RatingApiModule,
    LGPDBffModule,
    CheckupBffModule,
    DepartureDateBffModule,
    ExtraContributionBffModule,
    ValidationBffModule,
    NewContributionBffModule,
    ContributionManagerBffModule,
    NewDiversificationModule,
    JaiminhoApiModule,
    PortalModule,
    RenegotiationModule,
    DigitalSiteBffModule,
    PortalModule
  ],
  providers: [
    AuthGuard,
    FeatureFlagGuard,
    FeatureFlagService,
    UnsignedContractGuard,
    PlanTradUnsignedGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
